import PropTypes from "prop-types";
export var renderablePropType = PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.shape({
  render: PropTypes.func.isRequired
})]);